import type { ReactNode, Ref } from 'react'
import { forwardRef } from 'react'

import { focusVisible, customMedia } from '@space-lib/styles'

import styled, { css } from 'styled-components'

export type SearchProps = {
  children: ReactNode
  isMobile?: boolean
  isLoading?: boolean
}

const Search = styled.div<SearchProps>`
  position: relative;
  margin-bottom: 0.375rem;
  width: 0;
  height: 2.5rem;
  transition: all 0.8s var(--easing) calc(var(--timing) / 2), width 0.4s var(--easing);
  z-index: 2;

  ._close-search {
    display: none;
  }

  ._search-button {
    margin-right: 0.625rem;
  }

  &:focus-within {
    ${customMedia.lessThan('sm')`
      width: 80%;
    `}

    ${({ isMobile, isLoading }) =>
      css`
        position: ${isMobile ? 'absolute' : 'relative'};
        width: ${isMobile ? '90%' : '19rem'};
        background-color: ${isMobile ? 'var(--bg-primary);' : 'transparent'};
        right: ${isMobile ? '4.25rem' : '0'};

        ._close-search {
          display: flex;
          position: absolute;
          height: 2.5rem;
          width: 2.5rem;
          justify-content: center;
          left: 0;
        }

        input {
          width: ${isMobile ? '80%' : '100%'};
          position: ${isMobile ? 'absolute' : 'relative'};
          padding: 0.5rem 1rem !important;
          background-color: transparent !important;
          right: 0;
        }

        label {
          background-color: transparent;
          right: 0;

          button {
            &:focus {
              color: ${isLoading ? 'var(--gray-900) !important' : ''};
              background-color: var(--gray-900);
            }
          }
        }
      `}

    ._search-button {
      margin-right: 0.625rem;
      ${focusVisible}
    }
  }
`

const SearchField = ({ children, isMobile, isLoading }: SearchProps, ref: Ref<HTMLDivElement>) => {
  return (
    <Search
      slot='actions-end'
      className='_d-flex _justify-content-end'
      isMobile={isMobile}
      isLoading={isLoading}
      data-test='field-search'
      ref={ref}>
      {children}
    </Search>
  )
}

export default forwardRef(SearchField)
